module.exports = __webpack_public_path__ + "img/zs8.328a7676.png";